import React from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { compose } from 'recompose';
import { isEmpty } from 'lodash';
import { urlRegex, ipRegex } from './regex';

import { HHUrl, HHInput, HHFileUploader, HHTinyMCE, HHCheckbox } from './fields';

const formikEnhancer = withFormik({
  validationSchema: ({ translate }) =>
    Yup.object().shape({
      name: Yup.string().min(1, translate('form.error.string.min'))
        .max(60, translate('form.error.string.max'))
        .required(translate('form.error.mixed.required')),
      contentUrl: Yup.string().min(10, translate('form.error.string.min')).max(200, translate('form.error.string.min')) // .url(translate('form.error.string.url'))
        .test(
          'validUrl',
          translate('form.error.string.url'),
          // eslint-disable-next-line func-names, prefer-arrow-callback
          function (value) {
            return !value || urlRegex.test(value) || ipRegex.test(value);
          }
        ),
      fileUrl: Yup.string(),
      fileTempUrl: Yup.string().url(translate('form.error.string.url')),
      preview: Yup.string(),
      previewTempUrl: Yup.string().url(translate('form.error.string.url')),
      content: Yup.string(),
      description: Yup.string().max(128, translate('form.error.string.max')),
      isPublic: Yup.boolean()
    }),
  mapPropsToValues: props => props.initialValues,
  handleSubmit: (values, { props, setSubmitting, resetForm }) => {
    props.onSubmit(values).then(() => {
      setSubmitting(false);
      resetForm();
      if (props.handleClose) {
        props.handleClose();
      }
    });
  }
});

const ResourceForm = props => {
  const {
    handleClose,
    handleSubmit,
    isSubmitting,
    isEditing,
    translate,
    values,
    user,
    eventSlug,
    errors
  } = props;

  return (
    <Form onSubmit={handleSubmit} className='cms-resources_table_form'>
      <div className='cms-resources_table_form_formGroup'>
        <Form.Field width={16}>
          <label htmlFor='preview'>{translate('projectThumbnail')}</label>
          <Field
            name='preview'
            component={HHFileUploader}
            otherProps={{
              id: 'preview',
              type: 'image_16x9',
              fileType: 'event_resource_thumbnail',
              slug: eventSlug,
              userToken: user.token,
              trigger: (
                <Button
                  primary basic type='button'
                  color='blue'
                >
                  {translate('uploadThumbnail')}
                </Button>
              )
            }}
          />
          { ((!values.previewTempUrl && values.preview) || values.previewTempUrl) && (
            <img
              src={!values.previewTempUrl && values.preview ? values.preview : values.previewTempUrl && values.previewTempUrl}
              alt='Project Cover Background'
              className='mb1 upload-img-edit'
            />
          )}
        </Form.Field>

        <Form.Field width={16}>
          <label htmlFor='name'>{translate('form.label.title')} *</label>
          <Field
            name='name'
            component={HHInput}
            otherProps={{
              type: 'text',
              id: 'name'
            }}
          />
        </Form.Field>

        <Form.Field>
          <label htmlFor='contentUrl'>{translate('form.label.url')}</label>
          <Field
            name='contentUrl'
            component={HHUrl}
            otherProps={{
              id: 'contentUrl',
              type: 'text'
            }}
          />
        </Form.Field>

        <Form.Field>
          <label htmlFor='name'>{translate('form.label.fileUrl')}</label>
          <Field
            name='fileUrl'
            component={HHFileUploader}
            otherProps={{
              id: 'fileUrl',
              type: 'compression + document',
              fileType: 'event_resource_content',
              slug: eventSlug,
              userToken: user.token,
              contentId: values.id ? values.id : null,
              trigger: (
                <Button
                  primary basic type='button'
                  color='blue'
                >
                  {translate('Upload Your File')}
                </Button>
              )
            }}
          />
          {((!values.fileTempUrl && values.fileUrl) || values.fileTempUrl) && (
            <Button
              type='a' href={!values.fileTempUrl && values.fileUrl ? values.fileUrl : values.fileTempUrl && values.fileTempUrl} basic
              color='blue' target='_blank'
            >
              <i className='fal fa-arrow-to-bottom fa-mr' />
              {translate('Download')}
            </Button>
          )}
        </Form.Field>

        <Form.Field>
          <label htmlFor='name'>{translate('form.label.resourceIsPublic')}</label>
          <Field
            name='isPublic'
            component={HHCheckbox}
            otherProps={{
              isReversed: false,
              toggle: true
            }}
          />
        </Form.Field>


        <Form.Field>
          <label>{translate('Description')}</label>
          <Field
            name='content' component={HHTinyMCE}
            fileType='event_resource_description'
            slug={eventSlug}
            userToken={user.token}
          />
        </Form.Field>

      </div>

      <div className='cms-resources_table_form_btnGroup'>
        {handleClose && (
          <Button basic type='button' onClick={handleClose}>
            {translate('cancel')}
          </Button>
        )}
        <Button
          primary
          disabled={isSubmitting || !isEmpty(errors)}
          loading={isSubmitting}
          type='submit'
        >
          {isEditing ? translate('save') : translate('create')}
        </Button>
      </div>
    </Form>
  );
};

export default compose(
  withLocalize,
  formikEnhancer
)(ResourceForm);



// WEBPACK FOOTER //
// ./src/components/forms/resourceForm.js